(function () {
    'use strict';

    //Prompts can either be individual questions or groups of related questions (matrix)

    angular.module('cimerFrontEndApp').directive('surveyPrompt', [function () {
        return {
            restrict: 'EA',
            templateUrl: '/Content/Templates/survey/promptTemplate.html',
            scope: {
                prompt: '=surveyPrompt',
                displayOnly: '=displayOnly',
                showDisplayLogic: '=showDisplayLogic'
            },
            link: function (scope, elements, attrs) {
                scope.radioChanged = function () {
                    var scale;
                    for (var i = 0; i < scope.prompt.QuestionScale.length; i++) {
                        scale = scope.prompt.QuestionScale[i];
                        if (scale.IsOtherAnswer && scope.prompt.Answer !== scale.ScaleAnswerID) {
                            scope.prompt.OtherAnswerText = '';
                        }
                    }
                };
                scope.multiChanged = function () {
                    var scale;
                    for (var i = 0; i < scope.prompt.QuestionScale.length; i++) {
                        scale = scope.prompt.QuestionScale[i];
                        if (scale.IsOtherAnswer && !scope.prompt.MultiSelectAnswers[scale.ScaleAnswerID].Checked) {
                            scope.prompt.MultiSelectAnswers[scale.ScaleAnswerID].OtherAnswerText = '';
                        }
                    }
                };
            }
        };
    }]);

    angular.module('cimerFrontEndApp').filter('trustedHtml', ['$sce', function ($sce) {
        return function (html) {
            return $sce.trustAsHtml(html);
        };
    }]);

}());